import { useState } from "react";
import {
  AtsIntegration,
  WorkableIntegrationContext,
} from "./WorkableIntegrationContext";
import { WorkableSettingsStep } from "./components/steps/WorkableSettingsStep";
import { WorkableApiKeyStep } from "./components/steps/WorkableApiKeyStep";

export function WorkableIntegrationSetupPage() {
  const [atsIntegrationData, setAtsIntegration] = useState<AtsIntegration>({
    integration_id: "",
    api_key: "",
    customer_group_id: "",
    report_url_type: "CLIENT_PORTAL_URL",
  });
  const [currentStep, setCurrentStep] = useState(0);

  const steps = [
    <WorkableSettingsStep key="WorkableSettingsStep" />,
    <WorkableApiKeyStep key="WorkableApiKeyStep" />,
  ];

  const goToNextStep = () => setCurrentStep((curr) => curr + 1);
  const goToPrevStep = () => setCurrentStep((curr) => curr - 1);

  return (
    <WorkableIntegrationContext.Provider
      value={{
        atsIntegrationData,
        setAtsIntegration,
        currentStep,
        goToNextStep,
        goToPrevStep,
      }}
    >
      {steps[currentStep]}
    </WorkableIntegrationContext.Provider>
  );
}
